import { jsx as a } from "react/jsx-runtime";
const e = ({ name: r }) => /* @__PURE__ */ a("p", { className: "product-card-name", children: r });
export {
  e as ProductCardName
};
